module.exports = __webpack_public_path__ + "static/a511deb249ac3c102f25ee2f04b807e9010dca9831e8c9bbd9b712f0a0088648-c3a07a55373f8130a4c5264cf8d732d2.png";